module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/testimonial/testimonial-style3/testimonial-style3.component.scss
// module id = ./src/app/features/testimonial/testimonial-style3/testimonial-style3.component.scss
// module chunks = main